import CaffeineCacheDocumentation from 'components/lookup-tables/caches/CaffeineCacheDocumentation';
import CaffeineCacheSummary from 'components/lookup-tables/caches/CaffeineCacheSummary';

import MongoDBDataAdapterFieldSet from './components/MongoDBDataAdapterFieldSet';
import MongoDBDataAdapterSummary from './components/MongoDBDataAdapterSummary';
import MongoDBDataAdapterDocumentation from './components/MongoDBDataAdapterDocumentation';
import IlluminateCSVFileAdapterFieldSet from './components/IlluminateCSVFileAdapterFieldSet';
import IlluminateCSVFileAdapterSummary from './components/IlluminateCSVFileAdapterSummary';
import IlluminateCSVFileAdapterDocumentation from './components/IlluminateCSVFileAdapterDocumentation';
import IlluminateCacheFieldSet from './components/IlluminateCacheFieldSet';
import UploadCSVFileAdapterDocumentation from './components/UploadCSVFileAdapterDocumentation';
import UploadCSVFileAdapterFieldSet from './components/UploadCSVFileAdapterFieldSet';
import UploadCSVFileAdapterSummary from './components/UploadCSVFileAdapterSummary';

const lookupBindings = {
  lookupTableAdapters: [
    {
      type: 'mongodb',
      displayName: 'MongoDB',
      formComponent: MongoDBDataAdapterFieldSet,
      summaryComponent: MongoDBDataAdapterSummary,
      documentationComponent: MongoDBDataAdapterDocumentation,
    },
    {
      type: 'illuminate_csv',
      displayName: 'Illuminate Customizable',
      formComponent: IlluminateCSVFileAdapterFieldSet,
      summaryComponent: IlluminateCSVFileAdapterSummary,
      documentationComponent: IlluminateCSVFileAdapterDocumentation,
    },
    {
      type: 'uploadcsvfile',
      displayName: 'CSV File (Upload)',
      formComponent: UploadCSVFileAdapterFieldSet,
      summaryComponent: UploadCSVFileAdapterSummary,
      documentationComponent: UploadCSVFileAdapterDocumentation,
    },
  ],
  lookupTableCaches: [
    {
      type: 'illuminate_cache',
      displayName: 'Node-local, in-memory cache',
      formComponent: IlluminateCacheFieldSet,
      summaryComponent: CaffeineCacheSummary,
      documentationComponent: CaffeineCacheDocumentation,
    },
  ],
};

export default lookupBindings;
